import { atom } from 'recoil';
import {
  IntegrationCredentials,
  InterviewStage,
  RejectedReason
} from './types';

enum StateKey {
  IntegrationState = 'IntegrationState',
  IntegrationResolvedOrganization = 'IntegrationResolvedOrganization',
  RejectedReasons = 'RejectedReasons',
  InterviewStages = 'InterviewStages'
}

export const integrationAtom = atom<IntegrationCredentials | null>({
  key: StateKey.IntegrationState,
  default: null
});

/**
 * The organization the integration lookup has finished for, either way — not a
 * bare "have we looked yet" flag.
 *
 * `integrationAtom` alone cannot express this: `null` means both "no ATS is
 * connected" and "we have not looked yet", so anything branching on it treats
 * an unanswered question as a "no". Callers that choose between an ATS and a
 * non-ATS experience must wait for this rather than render on the default.
 *
 * It records *which* organization was answered because switching organization is
 * a soft switch with no reload (see changeOrganization). A boolean would stay
 * true across the switch, and the `preventInitialFetch` guard would then
 * suppress the refetch for the rest of the session — pinning every ATS/non-ATS
 * decision to whichever organization happened to be active first.
 */
export const integrationResolvedOrganizationAtom = atom<string | null>({
  key: StateKey.IntegrationResolvedOrganization,
  default: null
});

export const rejectedReasonsAtom = atom<RejectedReason[]>({
  key: StateKey.RejectedReasons,
  default: []
});

export const interviewStagesAtom = atom<InterviewStage[]>({
  key: StateKey.InterviewStages,
  default: []
});
